import { ApiEndpoints } from '../apiEndpoints.constant';
import { get, post } from '../request';
import { APP_CONFIG } from '@/config';
import { AddressChangeStatus, AddressChangeStatusRes } from '@/@types/addressChange';

export const startAddressChangeProcess = async (): Promise<any> => {
  return await post(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.addressChange}/start`, undefined, 'XSRF-TOKEN');
};

export const getAddressChangeStatus = async (): Promise<AddressChangeStatus> => {
  const response: AddressChangeStatusRes = await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.addressChange}/status`);
  return response.status;
};
